import React, { useState,useEffect } from "react";
import "./Testimonials.css";
import clientimg from "./../../assets/images/mahima.jpeg";
import clientimg2 from "./../../assets/images/tapsi.jpeg";
import clientimg3 from "./../../assets/images/sumit.jpeg";
import clientimg4 from "./../../assets/images/rishika.jpeg";
import clientimg5 from "./../../assets/images/testimonial4.png";
import Dialog from './../../assets/icons/Dialog.svg';
import startquote from './../../assets/icons/startquote.png';
import endquote from './../../assets/icons/endquote.png';

const testimonials = [
  {
    id: 1,
    name: "Mahima Baria",
    title: "Student, Navi Mumbai",
    img: clientimg,
    // shortTitle: "Lorem Ipsum has been the industry's standard dummy  text ever since",
    description:
      "I had no clue whether I should go for Science or Commerce. MentorX4u’s career assessment helped me understand my strengths, and the counsellor guided me with real clarity. I finally feel confident about my decision!",
  },
  {
    id: 2,
    name: "Tapsi Bahinipati",
    title: "Student, Berhampur",
    img: clientimg2,
    // shortTitle: "Lorem Ipsum has been the industry's standard dummy text ever since",
    description: "I was stuck in a course I didn’t enjoy. MentorX4u helped me explore better-aligned options and short-term skills to build my profile. I wish I had this guidance earlier!",
  },
  {
    id: 3,
    name: "Sumit Patel",
    title: "Student, Patna",
    img: clientimg3,
    // shortTitle: "Lorem Ipsum has been the industry's standard dummy text ever since",
    description: "After graduation, I was lost between job boards and advice from random people. MentorX4u gave me a clear roadmap with job options that matched my skills. I even got a referral from the RisoHire section!",
  },
   {
    id: 4,
    name: "Rishika Mishra",
    title: "Certified Career Counsellar, Delhi NCR",
    img: clientimg4,
    // shortTitle: "Lorem Ipsum has been the industry's standard dummy text ever since",
    description:
      "MentorX4u has helped me scale my counselling sessions with better data and insights. The AI recommendations save me time and the dashboard is simple to use. It's truly built for modern guidance.",
  },
 
];

export default function Testimonials() {
  const [active, setActive] = useState(0);
  //SLIDE EFFECT
  useEffect(() => {
    const interval = setInterval(() => {
      setActive((prev) => (prev + 1) % testimonials.length);
    }, 3000); // 3 seconds (change if needed)

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="testimonial-section">
      <div className="heading">
        <img src={Dialog} alt="Dialog Logo" className="dialog"></img>
        <h2 className="main-title">What Our Clients</h2>
        <h2 className="sub-title">Said about us?</h2>
        <div className="underline"></div>
      </div>

      <div className="testimonial-container">
        {testimonials.map((item, index) => {
          let position = "hidden";
          if (index === active) {
            position = "active";
          } else if (
            index === active - 1 ||
            (active === 0 && index === testimonials.length - 1)
          ) {
            position = "side left"; // Previous item
          } else if (
            index === active + 1 ||
            (active === testimonials.length - 1 && index === 0)
          ) {
            position = "side right"; // Next item
          }

          return (
            <div key={item.id} className={`testimonial-card ${position}`}>
              <div className="testimonial-content">
                <div className="client-info-section">
                  <div className="client-img">
                    <img
                      src={item.img}
                      className="testimonial-img"
                      alt="client"
                    />
                  </div>
                  <div className="client-info">
                    <h3 className="name">{item.name}</h3>
                    <p className="role">{item.title}</p>
                  </div>
                </div>
                <div className="text-box">
                  <p className="quote-title">
                    <span>
                      <img src={startquote} id="quote1" alt="quote"></img>
                    </span>
                    {item.shortTitle}
                  </p>
                  <p className="description">
                    {item.description}
                    <span>
                      <img src={endquote} id="quote2" alt="quote"></img>
                    </span>
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* slider dots */}
      <div className="dots">
        {testimonials.map((_, i) => (
          <span
            key={i}
            className={`dot ${active === i ? "active-dot" : ""}`}
            onClick={() => setActive(i)}
          ></span>
        ))}
      </div>
    </section>
  );
}